import pdfMake from 'pdfmake';
import handlePurchase from "@/services/modules/purchase";
import figureFormatter from '@/services/utils/figureFormatter'
import { formatAccountHeadLabel } from '@/services/utils/global'
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const ngoPdfPrinter = () => {
    const {currencyToDigitWord} = handlePurchase();
    const {commaFormat} = figureFormatter();
    const store = useStore();
    const getUserName = () => {
        const user = store.state.user.user;
        if (!user || !user.name) return '';
        return user.name;
    }
    const shouldInclude = (customizationFields, key) => !customizationFields || Object.keys(customizationFields).length === 0 || customizationFields[key];
    const defaultHiddenKeys = ['body_table_business_unit', 'body_table_cost_center', 'body_table_project', 'body_table_other_details', 'footer_note'];
    const accountHeadKeys = { payment: 'body_top_left_paid_from', receipt: 'body_top_left_received_in' };
    const isVisible = (customizationFields, key) => {
        if (!customizationFields || Object.keys(customizationFields).length === 0) return !defaultHiddenKeys.includes(key)
        return !!customizationFields[key]
    }

    const exportToPDF = (company, data, barcode, qrcode, btnFunc, customizationFields = []) => {
        var tableItems = getTableItems(data, (btnFunc === 'receipt' || btnFunc === 'contra'), btnFunc);
        if(btnFunc === 'contra'){
            var tableItemsDebit = getTableItems(data, false, btnFunc);
        }
        var doc = {
            pageSize: 'A4',
            pageMargins: [ 60, 100, 60, 80 ],
            header: getHeader(company, customizationFields),
            footer: getFooter(getUserName(), qrcode, customizationFields),
            content: getContent(data, tableItems, barcode, btnFunc, customizationFields),

            styles : {
                header: {
                    fontSize: 24,
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: data.voucher_no
            },
            pageBreakBefore: (currentNode) => breakBeforeSignature(currentNode, doc.content)
        }

        pushIntoTable(doc, data, tableItems, btnFunc, customizationFields)
        if(btnFunc === 'contra'){
            pushIntoDebitTable(doc, data, tableItemsDebit, btnFunc, customizationFields)
        }
        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }
    const formatDate = (date) => {
        if(!date) {
            return
        }
        var formattedDate = date.toISOString().split('T')[0];
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var amOrPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;
        return formatToDdMmYy(formattedDate) + ' ' + formattedTime
    }
    const formatToDdMmYy = (date) => {
        if(!date) {
            return
        }
        var dat = date.split('-');
        return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }
    const getHeader = (company, customizationFields) => {
        return {
            margin: [ 60, 25, 60, 10 ],
            columns: [
                (shouldInclude(customizationFields, 'heading_left_logo') && company.logo64)
                    ? {
                        alignment: 'left',
                        image: company.logo64,
                        maxHeight: 60
                    }
                    : null,

                {
                    alignment: 'right',
                    stack: [
                        (shouldInclude(customizationFields, 'heading_right_company_name') && company.name) ? company.name : '',
                        (shouldInclude(customizationFields, 'heading_right_company_address') && company.address) ? 'Address: ' + company.address : '',
                        (shouldInclude(customizationFields, 'heading_right_company_phone') && company.phone) ? 'Phone: ' + company.phone : '',
                        (shouldInclude(customizationFields, 'heading_right_company_email') && company.email) ? 'E-mail: ' + company.email : '',
                        getVatLine(company, customizationFields)
                    ]
                }
            ]
        }
    }
    const getVatLine = (company, customizationFields) => {
        if (!shouldInclude(customizationFields, 'heading_right_vat_reg_number')) return ''
        if (!company.vat_no) return ''
        if (company.vat_no === 'null') return ''
        return 'VAT/GST Reg No: ' + company.vat_no
    }
    const getName = (relation) => {
        if (!relation) return ''
        return relation.name || ''
    }
    const getUniqueNames = (ledgers, relation) => {
        const names = ledgers.map(ledger => getName(ledger[relation])).filter(name => name);
        return [...new Set(names)].join(', ')
    }
    const isTopAccountLedger = (ledger, btnFunc) => {
        if (ledger.label) return false
        if (btnFunc === 'payment') return ledger.debit === null || ledger.debit === 0
        if (btnFunc === 'receipt') return ledger.credit === null || ledger.credit === 0
        return false
    }
    const getTopLedgers = (data, btnFunc) => {
        const accountLedgers = data.ledgers.filter(ledger => isTopAccountLedger(ledger, btnFunc));
        if (accountLedgers.length > 0) return accountLedgers
        return data.ledgers
    }
    const getTopBusinessUnit = (data, topLedgers) => {
        if (data.business_name) return data.business_name
        return getUniqueNames(topLedgers, 'business')
    }
    const getLabelValue = (label, value) => {
        if (!value) return ''
        return { text: [{ text: label, bold: true }, { text: value }] }
    }
    const getVisibleLabelValue = (customizationFields, key, label, value) => {
        if (!isVisible(customizationFields, key)) return ''
        return getLabelValue(label, value)
    }
    const getContent = (data, tableItems, barcode, btnFunc, customizationFields) => {
        const accountHead = (btnFunc === 'payment') ?
                                        data.ledgers.find(i => (i.debit === null || i.debit === 0) && !i.label) :
                                        (btnFunc === 'receipt') ?
                                            data.ledgers.find(i => (i.credit === null || i.credit === 0) && !i.label)
                                            : null
        const topLedgers = getTopLedgers(data, btnFunc);
        const showChequeNo = isVisible(customizationFields, 'body_top_left_cheque_no') && btnFunc !== 'journal';
        const showChequeDate = isVisible(customizationFields, 'body_top_left_cheque_date') && btnFunc !== 'journal';
        return  [
            {
                text: getTitle(btnFunc),
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
            },

            {
                margin: [0, 20, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '40%',
                        stack: [
                            {
                                text: (accountHead && isVisible(customizationFields, accountHeadKeys[btnFunc])) ? [{text: (btnFunc === 'payment') ? 'PAID FROM: ' : (btnFunc === 'receipt') ? 'RECEIVED IN: ' : '' , bold: true}, {text: (btnFunc === 'contra') ? '' : formatAccountHeadLabel(accountHead.head) }] : ''
                            },

                            {
                                text: (data.cheque_number !== null && data.cheque_number !== undefined && data.cheque_number !== '' && showChequeNo)
                                    ? [{text: 'CHEQUE NO: ', bold: true }, { text: data.cheque_number }]
                                    : (data.payment_ref && showChequeNo)
                                        ? [{text: 'CHEQUE NO: ', bold: true }, { text: data.payment_ref }]
                                        : ''
                            },

                            {
                                text: (data.cheque_bank_statement_date !== null && data.cheque_bank_statement_date !== undefined && data.cheque_bank_statement_date !== '' && showChequeDate)
                                    ? [{text: 'CHEQUE DATE: ', bold: true }, {text: formatToDdMmYy(data.cheque_bank_statement_date) }]
                                    : (data.payment_ref_date && showChequeDate)
                                        ? [{text: 'CHEQUE DATE: ', bold: true }, {text: formatToDdMmYy(data.payment_ref_date) }]
                                        : ''
                            },

                            {
                                text: (btnFunc === 'journal' && isVisible(customizationFields, 'body_top_left_pr_po_reference') && tableItems.length > 0 && tableItems[0].txn_no) ? [ {text: 'PR / PO REFERENCE: ', bold: true }, { text: tableItems[0].txn_no} ] : ''
                            },

                            {
                                text: (btnFunc === 'journal' && isVisible(customizationFields, 'body_top_left_tag_reference') && tableItems.length > 0 && tableItems[0].tag_register) ? [ {text: 'TAG REFERENCE: ', bold: true }, { text: getName(tableItems[0].tag_register) } ] : ''
                            },

                            getVisibleLabelValue(customizationFields, 'body_top_left_cost_center', 'COST CENTER: ', getUniqueNames(topLedgers, 'cost_centre')),

                            getVisibleLabelValue(customizationFields, 'body_top_left_project', 'PROJECT: ', getUniqueNames(topLedgers, 'project')),
                        ]
                    },

                    {
                        alignment: 'right',
                        stack: [
                            {
                                text: isVisible(customizationFields, 'body_top_right_voucher_date') ? [ {text: 'VOUCHER DATE: ', bold: true }, {text: formatToDdMmYy(data.date)} ] : ''
                            },

                            {
                                text: isVisible(customizationFields, 'body_top_right_voucher_no') ? [ {text: 'VOUCHER NO: ', bold: true}, {text: data.voucher_no}] : ''
                            },

                            getVisibleLabelValue(customizationFields, 'body_top_right_business_unit', 'BUSINESS UNIT: ', getTopBusinessUnit(data, topLedgers)),

                            isVisible(customizationFields, 'body_top_right_barcode') ? { svg: barcode } : '',
                        ]
                    },
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: [],
                    body: []
                },
                layout: {
			          fillColor: function (rowIndex) {
                            return (rowIndex === 0 || rowIndex === tableItems.length + 1) ? '#f3f2f7' : null;
                        },
                    hLineWidth: function () {
                        return 0.5;
                    },
                    vLineWidth: function () {
                        return 0.5;
                    }
		        }
		    },

            (btnFunc === 'contra') ? {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: [],
                    body: []
                },
                layout: {
			        fillColor: function (rowIndex) {
                        return (rowIndex === 0 || rowIndex === tableItems.length + 1) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function () {
                        return 0.5;
                    },
                    vLineWidth: function () {
                        return 0.5;
                    }
		        }
		    } : '',

            isVisible(customizationFields, 'body_bottom_in_words_amount') ? {
                columns: [
                    {
                        width: '65%',
                        text: [
                            {
                                text: 'Amount in word: ',
                                bold: true
                            },

                            {
                                text: data.total_amount ? currencyToDigitWord((data.total_amount.toFixed(2)), false, true) : ''
                            }
                        ]
                    }
                ],
                margin: [0, 10]
            } : '',

            isVisible(customizationFields, 'body_bottom_voucher_memo') ? {
                alignment: 'justify',
                text: [{ text: data.note ? 'Voucher Memo \n' : '', bold: true}, {text: data.note} ]
            } : '',

            getSignatureGuard(),

            formatSignatureData(customizationFields)

        ]
    }
    const getSignatureGuard = () => ({ text: ' ', fontSize: 1, id: 'signature_guard' })
    const hasSignature = (signature) => signature.columns.some(column => column.stack.length > 0)
    const breakBeforeSignature = (currentNode, content) => {
        if (currentNode.id !== 'signature_guard') return false
        const signature = content[content.length - 1];
        if (!hasSignature(signature)) return false
        return currentNode.startPosition.top > signature.absolutePosition.y - 5
    }

    const getTitle = (btnFunc) => (btnFunc === 'payment') ? 'PAYMENT VOUCHER' : (btnFunc === 'receipt') ? 'RECEIPT VOUCHER' : (btnFunc === 'contra') ? 'CONTRA VOUCHER' : (btnFunc === 'journal') ? 'JOURNAL VOUCHER' : ''

    const getSingleSignatureContent = (title) => {
        return [
            {
                canvas: [
                    {
                        type: 'line',
                        x1: 0,
                        y1: 0,
                        x2: 58,
                        y2: 0,
                        lineWidth: 1
                    }
                ]
            },
            {
                margin: [ 0, 5, 0, 0 ],
                text: `${title} `,
                color: 'black',
                bold: true,
                alignment: 'left',
            }
        ]
    }

    const formatSignatureData = (customizationFields) => {
        const hasPrepared = shouldInclude(customizationFields, 'signature_prepared_by');
        const hasReviewed = shouldInclude(customizationFields, 'signature_reviewed_by');
        const hasReceived = shouldInclude(customizationFields, 'signature_received_by');
        const hasApproved = shouldInclude(customizationFields, 'signature_approved_by');

        let rightColumnSpacer = 0;
        let showReceived = hasReceived;
        let showApproved = hasApproved;

        if (showReceived && showApproved) {
            rightColumnSpacer = 40;
        }

        const topSpacerHeight = (showReceived && showApproved) ? 57 : 0;
        const startY = (showReceived && showApproved) ? 653 : 670;

        return {
            alignment: 'justify',
            absolutePosition: { x: 60, y: startY },
            columns: [
                {
                    width: '43%',
                    stack: hasPrepared ? [
                        topSpacerHeight > 0 ? { text: '', margin: [0, topSpacerHeight, 0, 0] } : null,
                        ...getSingleSignatureContent('Prepared By')
                    ].filter(Boolean) : []
                },
                {
                    width: '43%',
                    stack: hasReviewed ? [
                        topSpacerHeight > 0 ? { text: '', margin: [0, topSpacerHeight, 0, 0] } : null,
                        ...getSingleSignatureContent('Reviewed By')
                    ].filter(Boolean) : []
                },
                {
                    width: '43%',
                    stack: [
                        showReceived ? getSingleSignatureContent('Received By') : null,
                        (showReceived && showApproved) ? { text: '', margin: [0, rightColumnSpacer, 0, 0] } : null,
                        showApproved ? getSingleSignatureContent('Approved By') : null
                    ].filter(Boolean).flat()
                }
            ]
        }
    }

    const getFooter = (userName, qrcode, customizationFields) =>{
        return {
            margin: [ 60, 0, 60, 0 ],
            columns: [
                {
                    columns: [
                        (shouldInclude(customizationFields, 'footer_qrcode') && qrcode)
                            ? {
                                svg: qrcode
                            }
                            : null,

                        {
                            width: '90%',
                            alignment: 'left',
                            text: isVisible(customizationFields, 'footer_note') ? 'N.B: This is a system generated documents and requires no manual signature.' : '',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        }
                    ]

                },

                (shouldInclude(customizationFields, 'footer_printed_by') && userName)
                    ? {
                        width: '20%',
                        alignment: 'right',
                        fontSize: 8,
                        margin: [0, 33, 0, 0],
                        stack: [
                            {
                                text: 'Printed by',
                                bold: true
                            },
                            {
                                text: userName
                            },
                            {
                                text: formatDate(new Date())
                            }
                        ]
                    }
                    : null
            ]
        }
    }
    const getColumnRows = (data, tableItems, btnFunc) => {
        if (btnFunc === 'contra') return data.ledgers
        return tableItems
    }
    const pushIntoTable = (doc, data, tableItems, btnFunc, customizationFields) => {
        const columns = getTableColumns(btnFunc, customizationFields, getAccountsHeader(btnFunc, false), (btnFunc === 'receipt' || btnFunc === 'contra'), getColumnRows(data, tableItems, btnFunc));
        doc.content[2].table.widths = columns.map(column => column.width);
        doc.content[2].table.body.push(columns.map(column => column.header));
        tableItems.forEach(item => {
            doc.content[2].table.body.push(columns.map(column => column.cell(item)));
        });
        if(btnFunc === 'contra') return;
        if(!isVisible(customizationFields, 'body_totals_table_total_amount')) return;
        doc.content[2].table.body.push(getTotalRow(data, columns));
    }
    const pushIntoDebitTable = (doc, data, tableItemsDebit, btnFunc, customizationFields) => {
        const columns = getTableColumns(btnFunc, customizationFields, getAccountsHeader(btnFunc, true), false, getColumnRows(data, tableItemsDebit, btnFunc));
        doc.content[3].table.widths = columns.map(column => column.width);
        doc.content[3].table.body.push(columns.map(column => column.header));
        tableItemsDebit.forEach(item => {
            doc.content[3].table.body.push(columns.map(column => column.cell(item)));
        });
    }
    const getTableItems = (data, isDebitNull = false, btnFunc) => {
        if(btnFunc === 'journal'){
            return data.ledgers.sort((a, b) => {
                if (a.debit !== 0 && b.debit === 0) {
                  return -1;
                }
                if (a.debit === 0 && b.debit !== 0) {
                  return 1;
                }
                return 0;
            });
        }
        if(typeof data.ledgers === undefined){
            return [];
        }
        if(isDebitNull){
            return data.ledgers.filter(ledger => ledger.debit === null || ledger.debit === 0)
        }
        return data.ledgers.filter(ledger => ledger.credit === null || ledger.credit === 0)
    }
    const getAccountsHeader = (btnFunc, isReceivedSide) => {
        if(btnFunc !== 'contra') return 'Accounts Description'
        if(isReceivedSide) return 'Transfer to/Received in'
        return 'Transfer from/Paid from'
    }
    const getAccountsCell = (item, showActivity) => {
        return { stack: [
            { text: formatAccountHeadLabel(item.head) },
            { text: showActivity ? getName(item.activity) : '' },
            { text: getName(item.ngoab_head) }
        ]}
    }
    const getOtherDetails = (item) => [
        ['Budget: ', getName(item.budget)],
        ['Activity Head: ', getName(item.activity)],
        ['FD6 Budget: ', item.fd6_budget_master_name || ''],
        ['FD6 Activity: ', item.fd6_account_name || ''],
        ['Program: ', getName(item.program)],
        ['Donor: ', getName(item.donor)]
    ]
    const getOtherDetailsCell = (item) => {
        return { stack: getOtherDetails(item).map(([label, value]) => getLabelValue(label, value)) }
    }
    const getAmountColumns = (btnFunc, isDebitNull) => {
        if(btnFunc === 'journal') {
            return [
                { key: '', isAmount: true, width: 'auto', header: { text: 'Debit', alignment: 'right' }, cell: item => ({ text: item.debit ? commaFormat(item.debit) : '', alignment: 'right' }) },
                { key: '', isAmount: true, width: 'auto', header: { text: 'Credit', alignment: 'right' }, cell: item => ({ text: item.credit ? commaFormat(item.credit) : '', alignment: 'right' }) }
            ]
        }
        return [
            { key: '', isAmount: true, width: 'auto', header: { text: 'Amount', alignment: 'right' }, cell: item => ({ text: isDebitNull ? commaFormat(item.credit) : commaFormat(item.debit), alignment: 'right' }) }
        ]
    }
    const hasOtherDetails = (item) => getOtherDetails(item).some(([, value]) => !!value)
    const isColumnShown = (column, customizationFields, rows) => {
        if (!column.key) return true
        if (!isVisible(customizationFields, column.key)) return false
        if (!column.hasValue) return true
        return rows.some(column.hasValue)
    }
    const getTableColumns = (btnFunc, customizationFields, accountsHeader, isDebitNull, rows) => {
        const columns = [
            { key: 'body_table_business_unit', width: 'auto', header: { text: 'Business Unit' }, cell: item => ({ text: getName(item.business) }), hasValue: item => !!getName(item.business) },
            { key: 'body_table_cost_center', width: 'auto', header: { text: 'Cost Center' }, cell: item => ({ text: getName(item.cost_centre) }), hasValue: item => !!getName(item.cost_centre) },
            { key: 'body_table_project', width: 'auto', header: { text: 'Project' }, cell: item => ({ text: getName(item.project) }), hasValue: item => !!getName(item.project) },
            { key: 'body_table_other_details', width: 'auto', header: { text: 'Other Details' }, cell: item => getOtherDetailsCell(item), hasValue: item => hasOtherDetails(item) },
            { key: 'body_table_line_description', width: 'auto', header: { text: 'Line Description' }, cell: item => ({ text: item.note }) },
            { key: 'body_table_party_name', width: 'auto', header: { text: 'Party Name' }, cell: item => ({ text: getName(item.party) }) },
            ...getAmountColumns(btnFunc, isDebitNull)
        ].filter(column => isColumnShown(column, customizationFields, rows));
        const showActivity = !columns.some(column => column.key === 'body_table_other_details');
        return [{ key: '', width: '*', header: { text: accountsHeader }, cell: item => getAccountsCell(item, showActivity) }, ...columns]
    }
    const getTotalRow = (data, columns) => {
        const labelSpan = columns.filter(column => !column.isAmount).length;
        const spanFillers = Array(labelSpan - 1).fill('');
        const amounts = columns.filter(column => column.isAmount).map(() => commaFormat(data.total_amount));
        return [{ text: 'Total', alignment: 'right', colSpan: labelSpan }, ...spanFillers, ...amounts]
    }

    return {
        exportToPDF,
        formatDate
    }
}

export default ngoPdfPrinter;
